import React from 'react';
import './styles/index.css';
import './styles/flatpicker.css';
import './styles/custom-flatpicker.css';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from './App';
import 'react-toastify/dist/ReactToastify.css';
import { createRoot } from 'react-dom/client';
import store from '@redux/store';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <>
    <Router>
      <Provider store={store}>
        <App />
      </Provider>
    </Router>
  </>
);
